<div class="error-page ds" [attr.data-code]="code">
	<!-- Fondo decorativo -->
	<div class="error-background" aria-hidden="true">
		<div class="gradient-blob blob-1"></div>
		<div class="gradient-blob blob-2"></div>
	</div>

	<div class="error-card">
		<div class="error-visual">
			<div class="error-icon-shell">
				<mat-icon class="error-icon">{{ icon }}</mat-icon>
			</div>
			<div class="error-code">{{ code }}</div>
		</div>

		<div class="error-body">
			<h1 class="error-title">{{ titleKey | translate }}</h1>
			<p class="error-desc">{{ descriptionKey | translate }}</p>
			<p class="error-detail" *ngIf="errorState?.details">{{ errorState.details }}</p>
			<p class="error-timestamp" *ngIf="errorState?.timestamp">
				<mat-icon class="ts-icon">schedule</mat-icon>
				{{ errorState.timestamp | date : "medium" }}
			</p>

			<div class="error-actions">
				<button type="button" class="btn btn-primary" (click)="retrySession()">
					<span class="ic"><mat-icon>refresh</mat-icon></span>
					{{ "shared.errorPage.retry" | translate }}
				</button>
				<button type="button" class="btn btn-ghost" (click)="goHome()">
					<span class="ic"><mat-icon>home</mat-icon></span>
					{{ "shared.errorPage.home" | translate }}
				</button>
				<button type="button" class="btn btn-ghost" (click)="logout()">
					<span class="ic"><mat-icon>logout</mat-icon></span>
					{{ "shared.errorPage.logout" | translate }}
				</button>
			</div>

			<p class="error-support">
				{{ "shared.errorPage.support" | translate }}
				<a href="https://acciona.service-now.com/" target="_blank" rel="noopener noreferrer">
					{{ "shared.errorPage.supportLink" | translate }}
				</a>
			</p>
		</div>
	</div>
</div>
